import { useAtom } from "jotai";
import type { IProductWithCmsDataAndQualification } from "../../../features/products/type/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";
import { SubscriptionCartStore } from "../../stores/subscription-cart-store";

export function useSubscriptionCartStore() {
  const [subscriptionCart, setSubscriptionCart] = useAtom(SubscriptionCartStore);

  return {
    subscriptionCart,
    addProductToSubscriptionCart,
    resetSubscriptionCart,
  };

  function addProductToSubscriptionCart(product: IProductWithCmsDataAndQualification) {
    setSubscriptionCart(product);
  }

  function resetSubscriptionCart() {
    setSubscriptionCart(undefined);
  }
}
